import {connect} from "react-redux";
import ConversationsComponent from "../components/ConversationsComponent";
import {inboxSelector} from "../selectors";
import {conversationByIdsSelector} from "../../_data/selectors";
import Meta from "../../_data/models/Meta";
import {fetchConversations} from "../middlewares";

const mapStateToProps = (state, props) => {
    const {ids, meta, loading} = inboxSelector(state);   
    const conversations = conversationByIdsSelector(state, ids);

    return {
        conversations: conversations,
        meta: meta,
        loading: loading
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        loadMore: (meta: Meta) => {
            if (meta && meta.hasNext()) {
                dispatch(fetchConversations(meta.nextPage));
            }
        }
    };
};

const ConversationsContainer = connect(mapStateToProps, mapDispatchToProps)(ConversationsComponent);
export default ConversationsContainer;


// WEBPACK FOOTER //
// ./app/client/message/containers/ConversationsContainer.tsx